"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
var faCirclePause_1 = require("@fortawesome/pro-solid-svg-icons/faCirclePause");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var firestore_1 = require("firebase/firestore");
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var OutlinedTextButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/OutlinedTextButton"));
var analytics_1 = require("utils/analytics");
var hooks_1 = require("utils/hooks");
var Status = function (_a) {
    var item = _a.item;
    var matchStatus = item.matchStatus;
    var _b = __read((0, hooks_1.useSubmitter)('recharged_organizations', item.id), 2), rechOrgSubmitter = _b[0], isSending = _b[1];
    var setMatchStatus = function (newMatchStatus) { return rechOrgSubmitter({
        matchStatus: newMatchStatus, matchStatusSetOn: firestore_1.Timestamp.now(),
    }); };
    var track = (0, analytics_1.useTracker)();
    var undo = function () {
        var _a, _b;
        track('Recharges Mapping Reverted', {
            rechargedOrgId: item.id,
            rechargedOrgName: item.name,
            isSelectClear: true,
            previousRechargedCustomerName: (_a = item.customer) === null || _a === void 0 ? void 0 : _a.name,
            newRechargedCustomerName: (_b = item.customer) === null || _b === void 0 ? void 0 : _b.name,
        });
        setMatchStatus('none');
    };
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "space-around", width: 1, pr: 2.5 }, { children: matchStatus !== 'none'
            ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ title: matchStatus === 'confirmed' ? 'Confirmed' : 'Skipped', variant: "dark" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: matchStatus === 'confirmed' ? faCircleCheck_1.faCircleCheck : faCirclePause_1.faCirclePause, color: matchStatus === 'confirmed' ? '#30BC86' : '#EC7069' }) })), (0, jsx_runtime_1.jsx)(OutlinedTextButton_1.default, __assign({ isSending: isSending, color: "neutral", onClick: undo, className: "showOnHover" }, { children: "Undo" }))] }))
            : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(OutlinedTextButton_1.default, __assign({ color: "green", isSending: isSending, onClick: function () { return setMatchStatus('confirmed'); }, disabled: !item.customerId, sx: !item.customerId ? { opacity: 0, cursor: 'default' } : {} }, { children: "Confirm" })), (0, jsx_runtime_1.jsx)(OutlinedTextButton_1.default, __assign({ color: "neutral", isSending: isSending, onClick: function () { return setMatchStatus('skipped'); } }, { children: "Skip" }))] })) })));
};
exports.default = Status;
